module.exports = __webpack_public_path__ + "img/调研报告_01.43cc100b.svg";